// src/firebase.js

import { initializeApp } from 'firebase/app';
import { getAuth, onAuthStateChanged, signOut, updatePassword, sendEmailVerification } from "firebase/auth";
import { getFirestore } from 'firebase/firestore';
import { getStorage } from "firebase/storage";



// Initialize Firebase
const firebaseConfig = {
  apiKey: "AIzaSyB1EVceXRN_6D6k0qpN0Q6vRl-GZmutBY0",
  authDomain: "sp-community.firebaseapp.com",
  projectId: "sp-community",
  storageBucket: "sp-community.firebasestorage.app",
  messagingSenderId: "878529761323",
  appId: "1:878529761323:web:9acfaa6b25df9425a7da6e",
  measurementId: "G-8S29Q02Q58"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app); // Initialize auth with the app instance
const dbFirestore = getFirestore(app); // Initialize dbFirestore with the app instance
const storage = getStorage(app);


export { auth, dbFirestore, storage, onAuthStateChanged, signOut, updatePassword, sendEmailVerification }; // Export auth and dbFirestore directly
export default app;